import React, { useRef } from "react";
//Icons
import arrowDown from "../../assets/icons/down.svg";
import IdIcon from "../../assets/icons/idIcon.svg"; // icono de la ID
import UsarioIcon from "../../assets/icons/IconoUsuario.svg"; //icono del nombre Cliente
import CamionRepartoIcon from "../../assets/icons/camionRepartoIcon.svg"; //icono del camion con leche
import EditCampo from "../../assets/icons/editCampo.svg"; //icono para editar
import { useState, useEffect } from "react";
//axios
import axios from "axios";
//constantes
import * as Constant from "../../global/const";
import auth from "../../Helpers/auth";
import { useDispatch, useSelector } from "react-redux";
import { setSucursal } from "../../Redux/actions/PageActions";
import { useSucursal } from "../../Helpers/useSucursal";
import { ModalConfirmacionSucursal } from "./Modales/modalConfirmacionSucursal.component";
import { useHistory } from "react-router-dom";
//ppt-44 linea 88 cambiar esa vain

var Slider = {
  position: "absolute",
  backgroundColor: "#fff",
  border: "1px solid #0075bb",
  borderTop: "0",
  width: "100%",
  zIndex: "4",
  paddingRight: ".2rem",
  paddingTop: "1.5rem",
  height: "30vh",
  justifyContent: "center",
  top: "1rem",
  overflow: "hidden",
  opacity: "1",
  cursor: "auto",
  borderRadius: " 0 0 20px 20px",
  transition: "all 0.3s",
};

var CloseSlider = {
  height: 0,
  zIndex: "4",
  top: ".8rem",
  position: "absolute",
  backgroundColor: "#fff",
  border: "0px",
  justifyContent: "center",
  width: "100%",
  overflow: "hidden",
  opacity: "1",
  paddingTop: "1.5rem",
  transition: "all 0.3s",
};

const Second = (props) => {
  const [open, setopen] = useState(false);
  const history = useHistory();
  const [Allsucursales, setAllsucursales] = useState([]);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [valiteBranch, setValiteBranch] = useState(false);
  const [sucursales, setsucursales] = useState([]);
  const [sucursal, setsucursal] = useState(
    useSelector((state) => state.page.sucursal)
  );
  const [currentBranch, setCurrentBranch] = useState({});
  const [showTolltype, setShowTolltype] = useState(false); //tooltype
  const myRef = useRef();
  const user = JSON.parse(auth.getUsuario());

  const getSucursales = () => {
    axios
      .get(Constant.GETSUCRUSALES + "?correo=" + user.email)
      .then((response) => {
        setAllsucursales(response.data);
        setsucursales(response.data);
      })
      .catch((err) => {
        console.log("sucursales ", err);
      });
  };

  const { getValidarCatalogo } = useSucursal();

  const handleClickOutside = (event) => {
    if (myRef.current && !myRef.current.contains(event.target)) {
      setopen(false);
    }
  };

  const CambiarSucursal = (sucursal) => {
    dispatch(setSucursal(sucursal));
    getValidarCatalogo(sucursal)
      .then((response) => {
        setValiteBranch(false);
        setShowModal(false);
        //window.location.reload();
      })
      .finally(() => {
        history.push("/inicio");
      });
  };

  const handleOrden = (numOrden) => {
    const patronAlfanumerico = /^[a-zA-Z0-9ñÑ\s]*$/;
    if (patronAlfanumerico.test(numOrden)) {
      props.updateObservaciones(numOrden);
    } else {
      numOrden = "";
    }
  };

  useEffect(() => {
    getSucursales();

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (valiteBranch) {
      CambiarSucursal(currentBranch);
    }
  }, [valiteBranch]);

  return (
    <div className="content-steeps">
      <div className="steeps">
        <div className="steep-circle">2</div>
        <div className="description">
          <b>Segundo paso:</b> revisa y complemeta los datos para tu entrega.
        </div>
      </div>
      <div className="secondContent">
        <div className="secondTop">
          <div className="campoSecond">
            <img src={IdIcon} alt="" />
            <div>
              <div>
                <span>Código cliente</span>
              </div>
              <input type="text" value={sucursal && sucursal.codigo} readOnly />
            </div>
          </div>
          <div className="campoSecond">
            <img src={UsarioIcon} alt="" />
            <div>
              <div>
                <span className="textoBlack">Nombre cliente</span>
              </div>
              {/* No permitir mas de 64 caracteres */}
              <input
                className="inputEditable"
                type="text"
                value={sucursal && sucursal.razonsocial}
              />
              {user.tipoClienteUsuario === 1 && (
                <div className="float_second">
                  <div
                    className={
                      "tooltip-container-second " +
                      (showTolltype ? "show-tooltip" : "")
                    }
                  >
                    <span className="tooltip-trigger"></span>
                    <div className="tooltip-one">
                      <div className="txt" align="left">
                        <p>Ten en cuenta: </p>
                        <h6>
                          Al cambiar la dirección puede variar la disponibilidad
                          y los precios de los productos.{" "}
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div
                    className="btn_sucursales no-seleccionable"
                    ref={myRef}
                    onClick={() => setopen(!open)}
                    onMouseOver={() => setShowTolltype(true)}
                    onMouseOut={() => setShowTolltype(false)}
                  >
                    <span>Cambiar de sucursal</span>
                    <img src={arrowDown} alt="" />
                  </div>
                  <div
                    className="secondModal"
                    style={open ? Slider : CloseSlider}
                  >
                    <div className="opciones scrollSlider">
                      {sucursales.map((sucursal, i) => (
                        <div
                          key={i}
                          className="opcion"
                          onClick={() => {
                            setsucursal(sucursal);
                            setopen(false);
                            setShowModal(true);
                            setCurrentBranch(sucursal);
                          }}
                        >
                          <h6 className="no-seleccionable">
                            {sucursal.razonsocial}
                          </h6>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="campoSecond">
            <img src={CamionRepartoIcon} alt="" />
            <div>
              <div>
                <span>Dirección de entrega</span>
              </div>
              <input
                type="text"
                value={sucursal && sucursal.direccion + " " + sucursal.ciudad}
              />
            </div>
          </div>
        </div>
        <div className="secondBottom">
          <div className="campoSecond">
            <img src={EditCampo} alt="" />
            <div>
              <div>
                {
                  //<span className={"textoBlack " + (props.error ? ' error' : "")}>Digita el número de la orden</span>
                }
                <span className={"textoBlack"}>
                  Digita el número de la orden
                </span>
              </div>
              <input
                type="text"
                className="inputEditable"
                pattern="^[^\s]+$"
                placeholder="Escriba en este espacio tu número de orden"
                onChange={(event) => props.updateOrden(event.target.value)}
              />
            </div>
          </div>
          <div className="campoSecond">
            <img src={EditCampo} alt="" />
            <div>
              <div>
                <span className="textoBlack">Observaciones</span>
              </div>
              {props.observaciones.length >= 64 && (
                <span className="error">
                  La observacion debe ser menor a 64 caracteres
                </span>
              )}
              <input
                id="editable"
                type="text"
                className="inputEditable"
                placeholder="Escribe aquí si tienes algún comentario adicional"
                value={props.observaciones}
                onChange={(event) => handleOrden(event.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <ModalConfirmacionSucursal
          setShowModal={setShowModal}
          variable={valiteBranch}
          setVariable={setValiteBranch}
        />
      )}
    </div>
  );
};

export default Second;
